import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/missive-refresh.png")